import { Badge, Button, Layout, message, Modal, Space, Table } from "antd";
import PageHeader from "../../comps/pageHeader";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { useEffect, useState } from "react";
import { FetchSingleSession } from "../prof/profsSlice";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Parser from 'html-react-parser';
import moment from "moment";

function SingleSessionHistory(props) {

    let { id } = useParams();
    // eslint-disable-next-line no-unused-vars
    const [classId, sessionId] = id.split("-");

    // eslint-disable-next-line no-unused-vars
    const [cookies, setCookies, removeCookie] = useCookies();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedUserHistory, setSelectedUserHistory] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);
    const [singleUserModalOpen, setSingleUserModalOpen] = useState(false);
    const [exerciseResult, setExerciseResult] = useState(null);

    useEffect(() => {
        dispatch(FetchSingleSession(cookies, { sessionId }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const classroomSingle = useSelector((state) => state.profs.classroomSingle);
    const getSingleSessionSuccess = useSelector((state) => state.profs.getSingleSessionSuccess);
    const isLoadingSessionData = useSelector((state) => state.profs.isFetchingSingleSession);


    const handleSelectUserExo = (exists, record) => {
        if (!exists) {
            message.warning("Cet élève n'a pas fait d'exercice");
            return;
        }
        setExerciseResult(record.userExercise.exercise);
        setSelectedUser(record.pupil);
        setSelectedUserHistory(CreateSingleTableData(record, record.userExercise.exercise));
        setSingleUserModalOpen(true);
    }

    const exportMultipleToExcel = () => {
        if (!getSingleSessionSuccess) {
            message.error("Veuillez attendre que les données soient chargées.");
            return;
        }

        const data = getSingleSessionSuccess.classSession.sessionUserExercises;
        let datalessUserCounter = 0;
        const workbook = XLSX.utils.book_new();
        for (let i = 0; i < data.length; i++) {
            const pupilData = data[i].pupil;
            const userSessionData = data[i];

            if (!userSessionData.userExercise) {
                datalessUserCounter++;
                continue;
            }

            const sessionData = CreateSingleTableData(userSessionData, userSessionData.userExercise.exercise);

            const newData = ReformatUserSessionDataForXLSX(sessionData);

            const worksheet = XLSX.utils.json_to_sheet(newData);
            XLSX.utils.book_append_sheet(workbook, worksheet, pupilData.name);

        }
        if (datalessUserCounter === data.length) {
            message.error("Aucun des étudiants n'a fait l'exercice.");
            return;
        }
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Session_${moment().format("YYYY-MM-DD")}_${classroomSingle?.classroom.name}.xlsx`);
    };

    const exportToExcel = (data, filename, userName) => {
        const newData = ReformatUserSessionDataForXLSX(data);
        const worksheet = XLSX.utils.json_to_sheet(newData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, userName);
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `${filename}.xlsx`);
    };

    const columnsSession = [
        {
            title: 'Nom prénom',
            dataIndex: 'pupil',
            key: '_id',
            render: (pupil) => (<p>{pupil?.name}</p>),
            width: "400px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Statut',
            dataIndex: 'pupil',
            key: '_id',
            render: (pupil) => (<p>{
                (new Date() - new Date(pupil?.lastSeen)) / 1000 < 180 ? "En ligne" : "Hors Ligne"
            }</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Leçon',
            dataIndex: 'lesson',
            key: '_id',
            render: (lesson) => (<p>{lesson ? lesson.name : "Aucun exo"}</p>),
            // width: "600px",
            // ...getColumnSearchProps('code')
        },
        {
            title: 'Progression',
            dataIndex: 'userExercise',
            key: '_id',
            render: (exo) => (<p>{exo ? Math.floor(exo.answers.length / 12 * 100) + "%" : "Aucun exo"}</p>),
        },
        {
            title: 'Nbr. d\'Erreurs',
            dataIndex: 'userExercise',
            key: '_id',
            render: (exo) => (<p>{exo ? exo.answers.reduce((acc, num) => acc + (num === 0 ? 1 : 0), 0) : "Aucun exo"}</p>),
        },
        {
            title: 'Détails',
            dataIndex: 'userExercise',
            key: '_id',
            render: (data, record) => (
                <div >
                    <Button
                        style={{ width: "6vw", marginRight: "8px", color: "#39B13D", border: "none" }}
                        onClick={() => { handleSelectUserExo(data, record) }}
                    >
                        Voir
                    </Button>
                </div>
            ),
            width: "10vw"
            // ...getColumnFilterStatusProps('sent')
        }

    ];

    const columnsSingleSession = [
        {
            title: 'Question',
            dataIndex: 'Question',
            key: '_id',
            render: (content) => (<p>{content}</p>),
        },
        {
            title: 'Bonne réponse',
            dataIndex: 'Bonne réponse',
            key: '_id',
            render: (correction) => (<p>{correction}</p>),
        },
        {
            title: 'Réponse Étudiant',
            dataIndex: 'Réponse Étudiant',
            key: '_id',
            render: (answer) => (<div style={{ display: "flex", flexDirection: "row" }}>
                <Badge dot={true} color={answer === 0 ? "#FAAD14" : "#52C41A"} />
                <p style={{ marginLeft: "4px" }}>{answer === 0 ? "Faux" : "Juste"}</p>
            </div>),
        },
    ]

    return (
        <Space direction="vertical" style={{ width: '100%' }} size={[0, 48]}>
            <Layout>
                <PageHeader title={classroomSingle?.classroom.name} breadcrumbItems={[classroomSingle?.classroom.name, "Historique des leçons"]}>
                    <Button
                        className="buttonStyle"
                        style={{ marginTop: "20px", height: "32px", padding: "4px 24px" }}
                        onClick={() => { navigate("/dashboard/classes/classList") }}
                    > Revenir à la liste des classes </Button>
                </PageHeader>
                <div style={{
                    margin: "2em",
                    padding: "2em 4vw 2em 4vw",
                    display: "flex",
                    direction: "column",
                    justifyContent: "space-around",
                    backgroundColor: "#424242"
                }}>
                    <div className="buttonContainer">
                        <p style={{ color: "#fff", fontWeight: "600" }}>Exporter le résultat de la leçon :</p>
                        <Button
                            className="buttonStyle"

                            onClick={() => exportMultipleToExcel()}
                        >
                            Exporter
                        </Button>
                    </div>
                </div>
                <div
                    style={{
                        margin: "2em",
                        padding: "1em 2em",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "#Fff"
                    }}
                >
                    <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                    }}>
                        <h3>Liste des élèves de la classe {classroomSingle?.classroom.name}</h3>
                    </div>
                    <div style={{ padding: "12px 12px" }}>
                        <Table
                            loading={isLoadingSessionData}
                            dataSource={!getSingleSessionSuccess ? [] : getSingleSessionSuccess.classSession.sessionUserExercises}
                            columns={columnsSession}
                        />
                    </div>
                </div>
                <Modal
                    title={selectedUser ? selectedUser.name : ""}
                    open={singleUserModalOpen}
                    cancelText="Fermer"
                    onCancel={() => {
                        setSingleUserModalOpen(false);
                        setSelectedUserHistory(null);
                        setSelectedUser(null);
                    }}
                    onOk={() => { exportToExcel(selectedUserHistory, selectedUser?.name + "_Session", selectedUser?.name) }}
                    okText="Exporter"
                    width={"800px"}
                >
                    <p style={{ fontSize: "16px", marginTop: "8px", marginBottom: "16px" }}><b>Enoncé:</b> {Parser(exerciseResult ? exerciseResult.statement : "")}</p>

                    <Table
                        dataSource={selectedUserHistory}
                        columns={columnsSingleSession}
                    />
                </Modal>
            </Layout>
        </Space>
    );
}

function ReformatUserSessionDataForXLSX(data) {
    const tableData = []
    for (let i = 0; i < data.length; i++) {
        const element = data[i];
        const exoData = {
            'Réponse Étudiant': element['Réponse Étudiant'] === 0 ? "Faux" : "Juste",
            'Bonne réponse': element['Bonne réponse'],
            'Question': element['Question'],
        };
        tableData.push(exoData);
    }

    return tableData;
}
function CreateSingleTableData(selectedUserSession, exercise) {
    const tableData = [];

    for (let i = 0; i < selectedUserSession?.userExercise?.answers.length; i++) {
        const answer = selectedUserSession?.userExercise?.answers[i];

        const exoData = {
            'Réponse Étudiant': answer,
            'Bonne réponse': exercise.questions[i].correction.content,
            'Question': exercise.questions[i].content.join(" ")
        };
        tableData.push(exoData);
    }
    return tableData;
}

export default SingleSessionHistory;